import React from 'react';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvEmoji from 'shared/components/nv-emoji';
import AiQuestionsModalLoader from 'lecture_pages/components/quiz/ai-questions-modal-loader';
import { LoaderType } from 'shared/components/loading-placeholder';
import QuestionText from './question-text';
import { loadingDrawerState } from '../styles';

interface LoadingDrawerStateProps {
  question?: string;
  onCancel?: () => void;
}

const LoadingDrawerState = ({
  question,
  onCancel,
}: LoadingDrawerStateProps) => (
  <div css={loadingDrawerState}>
    <NvEmoji icon='light' size='large' />
    <QuestionText question={question} />
    <div className='loading-icon'>
      <AiQuestionsModalLoader loaderType={LoaderType.ICON_ONLY} />
    </div>
    <button type='button' onClick={onCancel} data-qa={config.pendo.aiLearning.cancelButton}>{t.FORM.CANCEL()}</button>
  </div>
);

export default LoadingDrawerState;
